<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-row>
      <b-col md="6" class="my-1">
        <b-navbar-nav>
          <b-button @click="goBack" size="sm" variant="light">
            <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
          </b-button>
        </b-navbar-nav>
        <h5 class="mt-1 mr-2">
          {{ $route.name }}
        </h5>
      </b-col>
      <b-col md="2">
        <h5>
          <small v-if="isLoading == false">{{ getContList.length }} Entries</small>
        </h5>
      </b-col>
      <b-col md="4">
        <b-button class="pull-right ml-1 mt-1" :variant="Filter.contractFilter ||
          Filter.commonFilter ||
          Filter.slineFilter ||
          Filter.porFilter ||
          Filter.polFilter ||
          Filter.podFilter ||
          Filter.fpodFilter ||
          Filter.territoryFilter ||
          Filter.containerTypeFilter ||
          Filter.createdByFilter ||
          Filter.statusFilter ||
          Filter.dateRange.startDate ||
          Filter.dateRange.endDate
          ? 'outline-danger'
          : 'outline-primary'
          " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
          aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
            Filter.contractFilter ||
              Filter.commonFilter ||
              Filter.slineFilter ||
              Filter.porFilter ||
              Filter.polFilter ||
              Filter.podFilter ||
              Filter.fpodFilter ||
              Filter.territoryFilter ||
              Filter.containerTypeFilter ||
              Filter.createdByFilter ||
              Filter.statusFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? "Filter ON"
              : "Filter OFF"
          }}</b-button>
        <b-button class="pull-right ml-1 mt-1" v-if="getContList.length > 0"
          :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
          @click="getReports('getContList', 'Export As Excel')" size="sm" variant="warning" style="font-size: 0.675rem">
          {{ ExcelBtnName }}
          <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
        <b-button size="sm" class="pull-right mt-1" @click="AddContractModal('add', '')"
          variant="primary">Add</b-button>
      </b-col>
      <div v-if="visible">
        <b-card>
          <b-collapse v-model="visible" id="collapse-2">
            <b-row>
              <b-col md="3">
                <label>Status</label>

                <model-list-select :list="StatusList" v-model="Filter.statusFilter" option-value="DVal"
                  option-text="DText" placeholder="Select"
                  @input="getContractList('Normal', '0', '0', '1', '1')"></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Date</label>
                <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                  :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                  @update="getContractList('Normal', '0', '0', '1', '1')"></date-range-picker>
              </b-col>

              <b-col md="3">
                <label>Shipping Line</label>
                <model-list-select :list="$store.getters['common/getAllShippingLineList']" v-model="Filter.slineFilter"
                  option-value="shippingId" option-text="shippingLine" placeholder="Select Shipping Line"
                  @input="getContractList('Normal', '0', '0', '1', '1')"></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Territory</label>
                <model-list-select :list="$store.getters['commonDropdownMaster/getAllENQTERIOTRYDDList']"
                  v-model="Filter.territoryFilter" option-value="text" option-text="text" placeholder="Select Territory"
                  @input="getContractList('Normal', '0', '0', '1', '1')"></model-list-select>
              </b-col>
              <b-col md="3">
                <label>POR</label>
                <model-list-select @input="
                  getLocationList($event, 'All', 'finalAllPlaceDataPOR');
                getContractList('Normal', '0', '0', '1', '1');
                " @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
                  :list="$store.getters['common/getAllPORList']" v-model="Filter.porFilter" option-value="pickupId"
                  option-text="pickupLocation" placeholder="Select POR"></model-list-select>
              </b-col>

              <b-col md="3">
                <label>POL</label>
                <model-list-select @input="
                  getLocationList($event, 'All', 'finalAllPlaceDataPO');
                getContractList('Normal', '0', '0', '1', '1');
                " @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                  :list="$store.getters['common/getAllPOLList']" v-model="Filter.polFilter" option-value="pickupId"
                  option-text="pickupLocation" placeholder="Select POL"></model-list-select>
              </b-col>
              <b-col md="3">
                <label>POD</label>
                <model-list-select @input="
                  getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                getContractList('Normal', '0', '0', '1', '1');
                " @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                  :list="$store.getters['common/getAllPODList']" v-model="Filter.podFilter" option-value="pickupId"
                  option-text="pickupLocation" placeholder="Select POD"></model-list-select>
              </b-col>
              <b-col md="3">
                <label>FPOD</label>
                <model-list-select @input="
                  getLocationList($event, 'All', 'finalAllPlaceDataPOD');
                getContractList('Normal', '0', '0', '1', '1');
                " @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
                  :list="$store.getters['common/getAllLocationDetailsFinalList']" v-model="Filter.fpodFilter"
                  option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Final Port of Discharge"></model-list-select>
              </b-col>
              <b-col md="3">
                <label>Container Type</label>
                <model-list-select :list="$store.getters['common/getAllContainerTypeList']"
                  v-model="Filter.containerTypeFilter" option-value="containerTypeId" option-text="containerType"
                  placeholder="Select Container Type"
                  @input="getContractList('Normal', '0', '0', '1', '1')"></model-list-select>
              </b-col>

              <b-col md="3">
                <label>Contract No Filter</label>
                <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Contract No Filter"
                  id="contractFilter" name="contractFilter" autocomplete="off" v-model="Filter.contractFilter"
                  @input="getContractList('Normal', '0', '0', '1', '1')" />
              </b-col>
              <b-col md="3">
                <label>Common Filter</label>
                <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Common Filter"
                  id="contractFilter" name="commonFilter" autocomplete="off" v-model="Filter.commonFilter"
                  @input="getContractList('Normal', '0', '0', '1', '1')" />
              </b-col>
              <b-col md="3">
                <label>
                  <b> Created User </b>
                </label>
                <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                  @input="getContractList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                  option-value="userId" option-text="employeeName"
                  placeholder="Select Created User"></model-list-select>
              </b-col>
              <b-col md="12" class="mt-2">
                <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                  variant="outline-danger">Reset</b-button>
              </b-col>
            </b-row>
          </b-collapse>
        </b-card>
      </div>
      <b-col cols="12">
        <div>
          <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total-rows="getContList.length" @change="onPageChange($event)"></b-pagination>
        </div>
      </b-col>
    </b-row>
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive tableMain gutr">
          <b-table show-empty stacked="md" responsive :items="getContList" :fields="contractFields"
            primary-key="clientId" class="position-relative" :per-page="pagination.perPage" :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
            <template slot="SN" slot-scope="row0">
              <span>{{
                row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
              }}</span>
            </template>
            <template slot="contarct_no" slot-scope="row1">
              <span v-if="row1.item.contarct_no">Contract No : {{ row1.item.contarct_no }}<br /></span>
              <span v-if="row1.item.contract_rate">Contract Rate : {{ row1.item.contract_rate }}<br /></span>
              <span v-if="row1.item.premium_contract_rate">Contract Premium Rate : {{ row1.item.premium_contract_rate
                }}<br /></span>
              <span v-if="row1.item.contract_start_date">Start Date : {{ row1.item.contract_start_date }}<br /></span>
              <span v-if="row1.item.contract_end_date">End Date : {{ row1.item.contract_end_date }}<br /></span>
            </template>
            <template slot="AllBookingNo" slot-scope="row3">
              <div v-if="row3.item.AllBookingNo">
                <span v-for="(item1, index) in row3.item.AllBookingNo.split(',')" :key="index">
                  <h6>
                    <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                    </b-badge>
                  </h6>
                </span>
              </div>
            </template>
            <template slot="allJobNo" slot-scope="row3">
              <div v-if="row3.item.allJobNo">
                <span v-for="(item1, index) in row3.item.allJobNo.split(',')" :key="index">
                  <h6>
                    <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                    </b-badge>
                  </h6>
                </span>
              </div>
            </template>
            <template slot="fk_por_id" slot-scope="row4">
              <span v-if="row4.item.POR">POR : {{ row4.item.POR }}<br /></span>
              <span v-if="row4.item.POL">POL : {{ row4.item.POL }}<br /></span>
              <span v-if="row4.item.POD">POD : {{ row4.item.POD }}<br /></span>
              <span v-if="row4.item.FPOD">FPOD : {{ row4.item.FPOD }}<br /></span>
              <span v-if="row4.item.containerType">Cont. Type : {{ row4.item.containerType }}<br /></span>
            </template>
            <template slot="raisedBy" slot-scope="row4">
              <span v-if="row4.item.raisedBy">Raised By : {{ row4.item.raisedBy }}<br /></span>
              <span v-if="row4.item.create_date">Created Date : {{ row4.item.create_date }}<br /></span>
              <span v-if="row4.item.updatedBy">Updated By : {{ row4.item.updatedBy }}<br /></span>
              <span v-if="row4.item.update_date">Updated Date : {{ row4.item.update_date }}<br /></span>
              <b-button size="sm" class="pull-left" @click="AddContractModal('edit', row4.item)"
                variant="primary">Edit</b-button>
            </template>
          </b-table>
        </div>
        <div>
          <b-pagination limit="25" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
            :total-rows="getContList.length" @change="onPageChange($event)"></b-pagination>
        </div>
      </div>
    </div>

    <b-modal no-close-on-esc no-close-on-backdrop class="w-90" size="xl" ref="modal-Add-Open" hide-footer
      :title="ContractDetails.ContractType == 'add' ? 'Add Contract' : 'Update Contract'">
      <b-row>
        <b-col cols="3" class="mt-2">
          <label for="bkgType">Territories</label>
          <multi-select :options="$store.getters['commonDropdownMaster/getAllENQTERIOTRYDDList']"
            :selected-options="Territories_items" v-model="ContractDetails.territories_ids"
            placeholder="Select Territories" :multiple="true"
            @select="SelectTerritories(ContractDetails, $event)"></multi-select>
          <span class="error" v-if="!ContractDetails.territories_ids">
            {{ errorContractDetails.territories_ids }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="cb_contarct_no">
            Contract No. :
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" v-model="ContractDetails.cb_contarct_no" type="text"
            placeholder="Enter Contract No" />
          <span class="error" v-if="!ContractDetails.cb_contarct_no">
            {{ errorContractDetails.cb_contarct_no }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="contract_from">
            From. :
            <span class="error">*</span>
          </label>
          <model-list-select :list="fromList" v-model="ContractDetails.contract_from" option-value="fromVal"
            option-text="fromText" placeholder="Select From"></model-list-select>

          <!-- <b-form-input
            :formatter="capitalizeAll"
            v-model="ContractDetails.contract_from"
            type="text"
            placeholder="Enter Contract From"
          /> -->
          <span class="error" v-if="!ContractDetails.contract_from">
            {{ errorContractDetails.contract_from }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="contract_to">
            To. :
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" v-model="ContractDetails.contract_to" type="text"
            placeholder="Enter Contract To" />
          <span class="error" v-if="!ContractDetails.contract_to">
            {{ errorContractDetails.contract_to }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Start Date :
            <span class="error">*</span>
            <br />
          </label>
          <date-picker :format="selectDateFormat" lang="en" :minute-step="1" name="start_date" id="start_date"
            v-model="ContractDetails.start_date"></date-picker>
          <br />
          <span class="error" v-if="!ContractDetails.start_date">{{
            errorContractDetails.start_date
          }}</span>
        </b-col>

        <b-col cols="3" class="mt-2">
          <label for="blType">
            End Date :
            <span class="error">*</span>
            <br />
          </label>
          <date-picker :format="selectDateFormat" lang="en" :minute-step="1" name="end_date" id="end_date"
            v-model="ContractDetails.end_date"></date-picker>
          <br />
          <span class="error" v-if="!ContractDetails.end_date">{{
            errorContractDetails.end_date
          }}</span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Specific Contract Dashboard :
            <span class="error">*</span>
          </label>

          <model-list-select :list="specificContractList" option-value="value" option-text="label" class="ml-2"
            v-model="ContractDetails.specific_contract_dashboard"
            placeholder="Select Specific Contract Dashboard"></model-list-select>
          <span class="error" v-if="!ContractDetails.specific_contract_dashboard">
            {{ errorContractDetails.specific_contract_dashboard }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2" v-if="ContractDetails.specific_contract_dashboard == 'Yes'">
          <label for="vessel_name">Vessel Name. :<span class="error"></span></label>
          <b-form-input :formatter="capitalizeAll" v-model="ContractDetails.vessel_name" type="text"
            placeholder="Enter Vessel Name" />
          <span class="error" v-if="!ContractDetails.vessel_name">{{ errorContractDetails.vessel_name }}</span>
        </b-col>
        <b-col cols="3" class="mt-2" v-if="ContractDetails.specific_contract_dashboard == 'Yes'">
          <label for="vessel_voyage_no">Voyage No. :<span class="error"></span></label>
          <b-form-input :formatter="capitalizeAll" v-model="ContractDetails.vessel_voyage_no" type="text"
            placeholder="Enter Voyage No" />
          <span class="error" v-if="!ContractDetails.vessel_voyage_no">{{ errorContractDetails.vessel_voyage_no
            }}</span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="blType">
            Shipping Line :
            <span class="error">*</span>
          </label>
          <model-list-select :list="$store.getters['common/getAllShippingLineList']" option-value="shippingId"
            option-text="shippingLine" class="ml-2" v-model="ContractDetails.fk_shpping_line_id"
            placeholder="Select Shipping Line"></model-list-select>
          <span class="error" v-if="!ContractDetails.fk_shpping_line_id">
            {{ errorContractDetails.fk_shpping_line_id }}
          </span>
        </b-col>

        <b-col cols="3" class="mt-2">
          <label for="fk_cont_type_id">
            Container Type :
            <span class="error"></span>
          </label>
          <multi-select :options="$store.getters['common/getAllContainerTypeList']"
            :selected-options="ContainerType_items" v-model="ContractDetails.fk_cont_type_id"
            placeholder="Select Container Type" :multiple="true"
            @select="SelectContainerType(ContractDetails, $event)"></multi-select>
          <!-- <model-list-select
            :list="$store.getters['common/getAllContainerTypeList']"
            option-value="containerTypeId"
            option-text="containerType"
            class="ml-2"
            v-model="ContractDetails.fk_cont_type_id"
            placeholder="Select Container Type"
          ></model-list-select> -->
          <span class="error" v-if="!ContractDetails.fk_cont_type_id">
            {{ errorContractDetails.fk_cont_type_id }}
          </span>
        </b-col>
        <b-col cols="12" v-if="this.ContainerType_items.length > 0">
          <table class="table table-sm table-bordered mt-2">
            <tbody style="background: white">
              <tr v-if="contractContainerArr.length > 0">
                <th scope="col" style="width: 5px">SN.</th>
                <th scope="col" style="width: 200px">Container Type</th>
                <th scope="col" style="width: 200px">Currency</th>
                <!-- <th scope="col" style="width: 180px">Buying Rate</th> -->
                <th scope="col" style="width: 180px">Premium Buying Rate</th>
                <!-- <th scope="col" style="width: 180px" v-if="ContractDetails.specific_contract_dashboard == 'Yes'">Selling Rate</th> -->
                <th scope="col" style="width: 180px" v-if="ContractDetails.specific_contract_dashboard == 'Yes'">Vessel Sail Date</th>
                <th scope="col" style="width: 180px" v-if="ContractDetails.specific_contract_dashboard == 'Yes'">Start Date</th>
                <th scope="col" style="width: 180px" v-if="ContractDetails.specific_contract_dashboard == 'Yes'">End Date</th>
                <th scope="col" style="width: 180px" v-if="ContractDetails.specific_contract_dashboard == 'Yes'">Vessel</th>
                <th scope="col" style="width: 180px">Tues Val</th>
                <th scope="col" style="width: 180px">Remark</th>
                <th scope="col" style="width: 5px">
                  Actions
                  <b-button v-if="this.ContractDetails.cb_id > 0" :disabled="this.ContainerType_items.length <= 0"
                    @click="addContainerRate(null)" size="sm">
                    <i class="fa fa-plus-circle ml-1"></i>
                  </b-button>
                </th>
              </tr>
              <tr v-for="(item, index) in contractContainerArr" :key="index">
                <th scope="row">{{ index + 1 }}.</th>
                <td>
                  <model-list-select :list="$store.getters['common/getAllContainerTypeList']"
                    v-model="item.fk_cont_type_id" option-value="containerTypeId" option-text="containerType"
                    placeholder="Select Container Type"></model-list-select>
                  <span class="error" v-if="item.fk_cont_type_id_err ? true : false">{{
                    item.fk_cont_type_id_err
                  }}</span>
                </td>
                <td>
                  <model-list-select :list="$store.getters['common/getAllCurrencyList']"
                    v-model="item.fk_currency_id" option-value="currency_id" option-text="currencyCode"
                    placeholder="Select Currency"></model-list-select>
                  <span class="error" v-if="item.fk_currency_id_err ? true : false">{{
                    item.fk_currency_id_err
                  }}</span>
                </td>
                <!-- <td>
                  <b-form-input style="width: 90%" :formatter="capitalizeAll" v-model="item.continer_contract_rate" type="number"
                    placeholder="Buying Rate" />
                  <span class="error" v-if="item.continer_contract_rate_err ? true : false">{{
                    item.continer_contract_rate_err }}</span>
                </td> -->
                <td>
                  <b-form-input style="width: 90%" :formatter="capitalizeAll" v-model="item.continer_premium_contract_rate" type="number"
                    placeholder="Premium Buying Rate" />
                  <span class="error" v-if="item.continer_premium_contract_rate_err ? true : false">{{
                    item.continer_premium_contract_rate_err }}</span>
                </td>
                <!-- <td v-if="ContractDetails.specific_contract_dashboard == 'Yes'">
                  <b-form-input style="width: 90%" :formatter="capitalizeAll" v-model="item.continer_contract_selling_rate" type="number"
                    placeholder="Selling Rate" />
                  <span class="error" v-if="item.continer_contract_selling_rate_err ? true : false">{{
                    item.continer_contract_selling_rate_err }}</span>
                </td> -->
                <td v-if="ContractDetails.specific_contract_dashboard == 'Yes'">
                  <date-picker style="width: 90%" :format="selectDateFormat" lang="en" :minute-step="1" name="vessel_sail_date" id="vessel_sail_date"
                    v-model="item.vessel_sail_date" placeholder="Enter Vessel Sail Date" />
                  <span class="error" v-if="item.vessel_sail_date_err ? true : false">{{
                    item.vessel_sail_date_err }}</span>
                </td>
                <td v-if="ContractDetails.specific_contract_dashboard == 'Yes'">
                  <date-picker style="width: 90%" :format="selectDateFormat" lang="en" :minute-step="1" name="start_date" id="start_date"
                    v-model="item.start_date" placeholder="Enter Start Date" />
                  <span class="error" v-if="item.start_date_err ? true : false">{{
                    item.start_date_err }}</span>
                </td>
                <td v-if="ContractDetails.specific_contract_dashboard == 'Yes'">
                  <date-picker style="width: 90%" :format="selectDateFormat" lang="en" :minute-step="1" name="end_date" id="end_date"
                    v-model="item.end_date" placeholder="Enter End Date" />
                  <span class="error" v-if="item.end_date_err ? true : false">{{
                    item.end_date_err }}</span>
                </td>
                <td v-if="ContractDetails.specific_contract_dashboard == 'Yes'">
                  <b-form-input :formatter="capitalizeAll" v-model="item.vessel_name" type="text"
                    placeholder="Vessel Name" />
                  <span class="error" v-if="item.vessel_name_err ? true : false">{{
                    item.vessel_name_err }}</span>

                  <b-form-input class="mt-2" :formatter="capitalizeAll" v-model="item.vessel_voyage_no" type="text"
                    placeholder="Voyage No" />
                  <span class="error" v-if="item.vessel_voyage_no_err ? true : false">{{
                    item.vessel_voyage_no_err }}</span>
                </td>

                <td>
                  <b-form-input :formatter="capitalizeAll" v-model="item.continer_tues_commitment_val" type="number"
                    placeholder=" TUES Commitment Volume" />
                  <span class="error" v-if="item.continer_tues_commitment_val_err ? true : false">{{
                    item.continer_tues_commitment_val_err }}</span>
                </td>
                <td>
                  <b-textarea rows="2" :formatter="capitalizeAll" v-model="item.continer_remark" type="text"
                    placeholder="Enter Remark"></b-textarea>
                </td>
                <td>
                  <b-button v-if="index > 0" size="sm" @click="removeContainerRate(index)">
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>

        <b-col cols="3" class="mt-2" v-if="this.ContainerType_items.length <= 0">
          <label for="contract_rate">
            Contract Rate. :
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" v-model="ContractDetails.contract_rate" type="text"
            placeholder="Enter Contract Rate" />
        </b-col>
        <b-col cols="3" class="mt-2" v-if="this.ContainerType_items.length <= 0">
          <label for="contract_volume">
            Contract Volumes. :
            <span class="error">*</span>
          </label>
          <b-form-input :formatter="capitalizeAll" v-model="ContractDetails.contract_volume" type="text"
            placeholder="Enter Contract Volumes" />
        </b-col>

        <b-col cols="3" class="mt-2">
          <label for="POR">
            POR :
            <span class="error"></span>
          </label>
          <model-list-select @input="
            getLocationList($event, 'All', 'finalAllPlaceDataPOR');
          " @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOR')"
            :list="$store.getters['common/getAllPORList']" v-model="ContractDetails.fk_por_id" option-value="pickupId"
            option-text="pickupLocation" placeholder="Select POR"></model-list-select>
          <span class="error" v-if="!ContractDetails.fk_por_id">
            {{ errorContractDetails.fk_por_id }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="POL">
            POL :
            <span class="error"></span>
          </label>
          <model-list-select @input="
            getLocationList($event, 'All', 'finalAllPlaceDataPOD');
          " @searchchange="getLocationList($event, 'All', 'finalAllPlaceDataPOD')"
            :list="$store.getters['common/getAllPOLList']" v-model="ContractDetails.fk_pol_id" option-value="pickupId"
            option-text="pickupLocation" placeholder="Select POL"></model-list-select>
          <span class="error" v-if="!ContractDetails.fk_pol_id">
            {{ errorContractDetails.fk_pol_id }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="POD">
            POD :
            <span class="error"></span>
          </label>
          <model-list-select @input="
            getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
          " @searchchange="getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');"
            :list="$store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList']"
            v-model="ContractDetails.fk_pod_id" option-value="pickupId" option-text="pickupLocation"
            placeholder="Select POD"></model-list-select>
          <span class="error" v-if="!ContractDetails.fk_pod_id">
            {{ errorContractDetails.fk_pod_id }}
          </span>
        </b-col>
        <b-col cols="3" class="mt-2">
          <label for="FPOD">
            FPOD :
            <span class="error"></span>
          </label>
          <model-list-select @input="
            getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
          " @searchchange="getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');"
            :list="$store.getters['enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList']"
            v-model="ContractDetails.fk_fpod_id" option-value="pickupId" option-text="pickupLocation"
            placeholder="Select Final Port of Discharge"></model-list-select>
          <span class="error" v-if="!ContractDetails.fk_fpod_id">
            {{ errorContractDetails.fk_fpod_id }}
          </span>
        </b-col>
        <b-col cols="12" class="mt-2">
          <label for="contract_remark">
            Contract Remark :
            <span class="error">*</span>
          </label>
          <b-textarea rows="2" :formatter="capitalizeAll" v-model="ContractDetails.contract_remark" type="text"
            placeholder="Enter Contract Remark"></b-textarea>
          <span class="error" v-if="!ContractDetails.contract_remark">
            {{ errorContractDetails.contract_remark }}
          </span>
        </b-col>

        <b-col cols="12" class="text-center">
          <b-button :disabled="isCBdisabled" class="mt-3 sm" variant="success"
            v-if="ContractDetails.cb_contarct_no != ''" @click="submitContract">{{ buttonTxt }}</b-button>
          <b-button class="mt-3 sm" variant="outline-danger" @click="closeModalAdd">Close</b-button>
        </b-col>
      </b-row>
    </b-modal>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>
<style>
.w-90 .modal-dialog {
  max-width: 90% !important;
  margin: 0 auto !important;
}
</style>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import {
  lastVisitPage,
  globalPermissionStatus,
  GlobalGetLocation,
} from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import AccountService from "../../services/AccountService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch(
      "common/setAllLocationDetailsFinalList",
      JSON.stringify({
        itemCode: "LocationDetailsFinalList",
      })
    );
    this.$store.dispatch(
      "common/setAllPORList",
      JSON.stringify({
        itemCode: "PORList",
      })
    );
    this.$store.dispatch(
      "common/setAllPODList",
      JSON.stringify({
        itemCode: "PODList",
        type: "Normal",
        Territory: "",
      })
    );
    this.$store.dispatch(
      "common/setAllPOLList",
      JSON.stringify({
        itemCode: "POLList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllENQTERIOTRYDDList",
      JSON.stringify({
        itemCode: "getLocationTeratoryDetails",
        type: "Normal",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePODDDList",
      })
    );
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllCurrencyList",
      JSON.stringify({ Currency: "Currency_DropDown" })
    );

    if (globalPermissionStatus("Pridel Document")) {
      this.$store.dispatch("setCurrentRoute", "/console_booking/ContarctList");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.getContractList("Normal", "0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  mounted() { },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      selectDateFormat,
      validate: false,
      isCBdisabled: false,
      buttonTxt: "Save",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      ContainerType_items: [],
      Territories_items: [],
      visible: false,
      getContList: [],
      totalData: 0,
      contractFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },
        {
          key: "contarct_no",
          mainkey: "contarct_no",
          label: "Contract No",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },

        {
          key: "shippingLine",
          mainkey: "shippingLine",
          label: "Shipping Line",
          sortable: true,
          sortDirection: "ASC",
          table: "D.",
        },
        {
          key: "AllBookingNo",
          mainkey: "AllBookingNo",
          label: "Linked Booking No",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "AllBookingNoCount",
          mainkey: "AllBookingNoCount",
          label: "Booking No Count",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "allJobNoCount",
          mainkey: "allJobNoCount",
          label: "Job No Count",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "allJobNo",
          mainkey: "allJobNo",
          label: "Linked Job No",
          sortable: true,
          sortDirection: "ASC",
          table: "E.",
        },
        {
          key: "fk_por_id",
          mainkey: "fk_por_id",
          label: "Loc Det.",
          sortable: true,
          sortDirection: "ASC",
          table: "F.",
        },
        {
          key: "contract_remark",
          mainkey: "contract_remark",
          label: "Remark",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "raisedBy",
          mainkey: "raisedBy",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],
      pagination: {
        currentPage: 1,
        perPage: 25,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      docURL: URL_BASE_DOC,
      fromList: [
        {
          fromVal: "India",
          fromText: "India",
        },
        {
          fromVal: "India-ICD",
          fromText: "India-ICD",
        },
        {
          fromVal: "India Sea Port",
          fromText: "India Sea Port",
        },
        {
          fromVal: "Third Country",
          fromText: "Third Country",
        },
      ],
      StatusList: [
        {
          DVal: "0",
          DText: "In-ACtive",
        },
        {
          DVal: "1",
          DText: "Active",
        },
        {
          DVal: "2",
          DText: "All",
        },
      ],
      specificContractList: [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
      ],
      Filter: {
        contractFilter: "",
        commonFilter: "",
        slineFilter: "",
        porFilter: "",
        polFilter: "",
        podFilter: "",
        fpodFilter: "",
        territoryFilter: "",
        containerTypeFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
      validateCONC: true,
      contractContainerArr: [
        {
          fk_cont_type_id: "",
          fk_currency_id:"1",
          continer_type_name: "",
          continer_contract_rate: "",
          continer_premium_contract_rate: "",
          continer_remark: "",
          continer_tues_commitment_val: "",
          vessel_voyage_no: "",
          vessel_name: "",
          vessel_sail_date: "",
          start_date: "",
          end_date: "",
          continer_contract_selling_rate: "",

          fk_currency_id_err: "",
          fk_cont_type_id_err: "",
          continer_contract_rate_err: "",
          continer_remark_err: "",
          continer_premium_contract_rate_err: "",
          continer_tues_commitment_val_err: "",

          vessel_voyage_no_err: "",
          vessel_name_err: "",
          vessel_sail_date_err: "",
          start_date_err: "",
          end_date_err: "",
          continer_contract_selling_rate_err: "",
        },
      ],
      ContractDetails: {
        cb_id: "",
        ContractType: "add",
        fk_shpping_line_id: "",
        specific_contract_dashboard: "",
        vessel_name: "",
        vessel_voyage_no: "",
        fk_cont_type_id: "",
        fk_por_id: "",
        fk_pol_id: "",
        fk_pod_id: "",
        fk_fpod_id: "",
        cb_contarct_no: "",
        start_date: "",
        end_date: "",
        contract_from: "",
        contract_to: "",
        contract_rate: "",
        contract_volume: "",
        contract_remark: "",
        territories_ids: "",
        territoriesName: "",
        contTypeName: "",
        Territories_items: [],
        ContainerType_items: [],
      },
      errorContractDetails: {
        fk_shpping_line_id: "",
        specific_contract_dashboard: "",
        // fk_cont_type_id: "",
        // fk_por_id: "",
        // fk_pol_id: "",
        // fk_pod_id: "",
        // fk_fpod_id: "",
        cb_contarct_no: "",
        start_date: "",
        end_date: "",
        contract_from: "",
        contract_to: "",
        territories_ids: "",
      },
      arrayErrorContractDetails: [
        {
          cb_contarct_no: "Please Enter Contract number",
          specific_contract_dashboard: "Please Select Specific Contract Dashboard",
          start_date: "Please Select Contract Start Date",
          end_date: "Please Select Contract End Date",
          contract_from: "Please Enter Contract From",
          contract_to: "Please Enter Contract To",
          // fk_cont_type_id: "Please Select Container Type",
          fk_shpping_line_id: "Please Select Shipping Line",
          // fk_por_id: "Please Select POR",
          // fk_pol_id: "Please Select POL",
          // fk_pod_id: "Please Select POD",
          // fk_fpod_id: "Please Select FPOD",
          territories_ids: "Please Select Territories",
        },
      ],
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {},
  watch: {
    JOBSERIES: {
      handler: function (newVal, oldVal) {
        this.getData();
      },
      deep: true,
    },
  },
  methods: {
    clearContract() {
      this.ContainerType_items = [];
      this.Territories_items = [];
      this.contractContainerArr = [];
      this.ContractDetails = {
        cb_id: "",
        ContractType: "add",
        fk_shpping_line_id: "",
        specific_contract_dashboard: "",
        vessel_name: "",
        vessel_voyage_no: "",
        fk_cont_type_id: "",
        fk_por_id: "",
        fk_pol_id: "",
        fk_pod_id: "",
        fk_fpod_id: "",
        cb_contarct_no: "",
        start_date: "",
        end_date: "",
        contract_from: "",
        contract_to: "",
        contract_rate: "",
        contract_volume: "",
        contract_remark: "",
        territories_ids: "",
        contTypeName: "",
        territoriesName: "",
        Territories_items: [],
        ContainerType_items: [],
      };
    },
    addContainerRate(ContainerType_items) {
      this.ContainerType_items = ContainerType_items;
      this.ContractDetails.fk_cont_type_id = "";
      this.ContractDetails.contTypeName = "";
      if (!this.ContractDetails.cb_id) {
        this.contractContainerArr = []; // Reset array only when cb_id is blank
      }

      if (ContainerType_items.length > 0) {
        this.ContractDetails.ContainerType_items = ContainerType_items;

        ContainerType_items.forEach((element) => {
          let obj = {
            fk_cont_type_id: element.value,
            continer_type_name: element.text,
            fk_currency_id: "1",
            continer_contract_rate: "",
            continer_premium_contract_rate: "",
            continer_remark: "",
            continer_tues_commitment_val: "",
            vessel_voyage_no: "",
            vessel_name: "",
            vessel_sail_date: "",
            start_date: "",
            end_date: "",
            continer_contract_selling_rate: "",

            fk_currency_id_err: "",
            fk_cont_type_id_err: "",
            continer_contract_rate_err: "",
            continer_premium_contract_rate_err: "",
            continer_remark_err: "",
            continer_tues_commitment_val_err: "",
            vessel_voyage_no_err: "",
            vessel_name_err: "",
            vessel_sail_date_err: "",
            start_date_err: "",
            end_date_err: "",
            continer_contract_selling_rate_err: "",
          };

          // Check if container type already exists in the array
          let existingIndex = this.contractContainerArr.findIndex(
            (item) => item.fk_cont_type_id === element.value
          );

          if (existingIndex === -1) {
            // If not exists, push new container
            this.contractContainerArr.push(obj);
          } else {
            // If exists, update container type name
            this.contractContainerArr[existingIndex].continer_type_name = element.text;
          }
        });
      }
    },
    addContainerRateBak(ContainerType_items) {
      if (!this.ContractDetails.cb_id) {
        this.contractContainerArr = [];
        if (ContainerType_items.length > 0) {
          this.ContractDetails.ContainerType_items = ContainerType_items;
          ContainerType_items.forEach((element) => {
            let obj = {
              fk_cont_type_id: element.value,
              continer_type_name: element.text,
              continer_contract_rate: "",
              continer_premium_contract_rate: "",
              continer_remark: "",
              continer_tues_commitment_val: "",

              vessel_voyage_no: "",
              vessel_name: "",
              vessel_sail_date: "",
              start_date: "",
              end_date: "",
              continer_contract_selling_rate: "",

              fk_cont_type_id_err: "",
              continer_contract_rate_err: "",
              continer_contract_rate_err: "",
              continer_premium_contract_rate_err: "",
              continer_remark_err: "",
              continer_tues_commitment_val_err: "",
              vessel_voyage_no_err: "",
              vessel_name_err: "",
              vessel_sail_date_err: "",
              start_date_err: "",
              end_date_err: "",
              continer_contract_selling_rate_err: "",
            };
            this.contractContainerArr.push(obj);
          });
        }
      } else {
        let obj = {
          fk_cont_type_id: "",
          continer_type_name: "",
          continer_contract_rate: "",
          continer_premium_contract_rate: "",
          continer_remark: "",
          continer_tues_commitment_val: "",
          vessel_voyage_no: "",
          vessel_name: "",
          vessel_sail_date: "",
          start_date: "",
          end_date: "",
          continer_contract_selling_rate: "",

          fk_cont_type_id_err: "",
          continer_contract_rate_err: "",
          continer_contract_rate_err: "",
          continer_premium_contract_rate_err: "",
          continer_remark_err: "",
          continer_tues_commitment_val_err: "",
          vessel_voyage_no_err: "",
          vessel_name_err: "",
          vessel_sail_date_err: "",
          start_date_err: "",
          end_date_err: "",
          continer_contract_selling_rate_err: "",
        };
        this.contractContainerArr.push(obj);
      }
    },
    removeContainerRate(index) {
      this.contractContainerArr.splice(index, 1);
    },
    validateCONCDetail() {
      // let validate_new = true;
      // let errCount = 0;

      // let MainARR = this.contractContainerArr;
      // for (let j = 0; j < MainARR.length; j++) {
      //   // if (MainARR[j].fk_cont_type_id == "") {
      //   //   this.contractContainerArr[j].fk_cont_type_id_err =
      //   //     "Container Type " + parseInt(j + 1) + " Field is Required";
      //   //   validate_new = false;
      //   //   ++errCount;
      //   // } else {
      //   //   this.contractContainerArr[j].fk_cont_type_id_err = "";
      //   //   validate_new = true;
      //   // }

      //   if (MainARR[j].continer_contract_rate == "") {
      //     this.contractContainerArr[j].continer_contract_rate_err =
      //       "Contract Rate " + parseInt(j + 1) + " Field is Required";
      //     validate_new = false;
      //     ++errCount;
      //   } else {
      //     this.contractContainerArr[j].continer_contract_rate_err = "";
      //     validate_new = true;
      //   }

      //   if (MainARR[j].continer_tues_commitment_val == "") {
      //     this.contractContainerArr[j].continer_tues_commitment_val_err =
      //       "Contract Commitment TEUS Values " + parseInt(j + 1) + " Field is Required";
      //     validate_new = false;
      //     ++errCount;
      //   } else {
      //     this.contractContainerArr[j].continer_tues_commitment_val_err = "";
      //     validate_new = true;
      //   }
      // }
      // if (errCount > 0) {
      //   this.validateCONC = false;
      // } else {
      //   this.validateCONC = true;
      // }
    },
    AddContractModal(type, item) {
      this.clearContract();
      this.ContractDetails.ContractType = type;
      if (type == "edit") {
        console.log("item=>", item);
        this.ContractDetails.ContractType = type;
        this.ContractDetails.fk_shpping_line_id = item.fk_shpping_line_id;
        this.ContractDetails.specific_contract_dashboard = item.specific_contract_dashboard;
        this.ContractDetails.vessel_name = item.vessel_name;
        this.ContractDetails.vessel_voyage_no = item.vessel_voyage_no;

        this.ContractDetails.fk_cont_type_id = item.fk_cont_type_id ? item.fk_cont_type_id : [];
        this.ContractDetails.fk_por_id = item.fk_por_id;
        this.ContractDetails.fk_pol_id = item.fk_pol_id;
        this.ContractDetails.fk_pod_id = item.fk_pod_id;
        this.ContractDetails.fk_fpod_id = item.fk_fpod_id;
        this.ContractDetails.cb_id = item.cb_id;
        this.ContractDetails.cb_contarct_no = item.contarct_no;
        this.ContractDetails.start_date = item.start_date;
        this.ContractDetails.end_date = item.end_date;
        this.ContractDetails.contract_from = item.contract_from;
        this.ContractDetails.contract_to = item.contract_to;
        this.ContractDetails.contract_rate = item.contract_rate;
        this.ContractDetails.contract_volume = item.contract_volume;
        this.ContractDetails.contract_remark = item.contract_remark;
        this.ContractDetails.ContainerType_items = item.ContainerType_items ? item.ContainerType_items : [];
        this.ContainerType_items = item.ContainerType_items ? item.ContainerType_items : [];
        this.Territories_items = item.Territories_items ? item.Territories_items : [];
        this.contractContainerArr = item.contractContainerArr;
        this.ContractDetails.Territories_items = item.Territories_items ? item.Territories_items : [];
        this.ContractDetails.territories_ids = item.territories_ids ? item.territories_ids : [];

        this.buttonTxt = "Update";
      }
      console.log("this.ContractDetails=>", this.ContractDetails);
      this.$refs["modal-Add-Open"].show();
    },
    validateContract() {
      let validate_new = true;

      this.errorContractDetails = {
        fk_shpping_line_id: "",
        specific_contract_dashboard: "",
        fk_cont_type_id: "",
        // fk_por_id: "",
        // fk_pol_id: "",
        // fk_pod_id: "",
        // fk_fpod_id: "",
        cb_contarct_no: "",
        start_date: "",
        end_date: "",
        contract_from: "",
        contract_to: "",
        territories_ids: "",
      };

      Object.keys(this.errorContractDetails).map((x, index) => {
        if (this.ContractDetails[x] == "") {
          console.log("this.ContractDetails[x]=>", this.ContractDetails[x]);
          console.log("x=>", x);
          console.log("y=>", this.arrayErrorContractDetails[0][x]);
          if (x == "bookingType") {
          }
          this.errorContractDetails[x] = this.arrayErrorContractDetails[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    submitContract() {
      this.validateContract();
      if (this.validate == false) return false;

      this.isLoading = true;
      this.isCBdisabled = true;
      this.ContractDetails.contractContainerArr = this.contractContainerArr;
      if (this.validate != false) {
        let payload = {
          itemCode: "upsertContract",
          contractData: this.ContractDetails,
        };
        AccountService.getAllContractList(payload)
          .then((response) => {
            const { data, status, statusText } = response;

            if (status == 200 && data) {
              if (data.cb_id != "" && data.cb_id != undefined) {
                if (data.find == 1) {
                  this.alert.content = data.MSG;
                  this.validate = true;
                } else {
                  this.alert.content = data.MSG;
                  this.validate = true;
                }
              } else {
                this.alert.content = data.MSG;
                this.validate = true;
              }
              this.isCBdisabled = false;
              Object.keys(this.ContractDetails).map((x, index) => {
                this.ContractDetails[x] = "";
              });
              this.$refs["modal-Add-Open"].hide();
              this.$refs["addPop"].open();
              this.getContractList("Normal", "0", "0", "1", "1");
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on submitContract Error: ", error);
          });
      }
    },
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };

      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    closeModalAdd() {
      this.$refs["modal-Add-Open"].hide();
    },
    clearFilter() {
      this.Filter = {
        contractFilter: "",
        commonFilter: "",
        slineFilter: "",
        porFilter: "",
        polFilter: "",
        podFilter: "",
        fpodFilter: "",
        territoryFilter: "",
        containerTypeFilter: "",
        createdByFilter: "",
        statusFilter: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },
    SelectTerritories(item, Territories_items) {
      this.Territories_items = Territories_items;
      this.ContractDetails.territories_ids = "";
      this.ContractDetails.territoriesName = "";
      if (Territories_items.length > 0) {
        this.ContractDetails.Territories_items = Territories_items;
        Territories_items.forEach((element) => {
          if (!this.ContractDetails.territories_ids) {
            this.ContractDetails.territories_ids = element.value;
            this.ContractDetails.territoriesName = element.text;
          } else {
            this.ContractDetails.territories_ids =
              this.ContractDetails.territories_ids + "," + element.value;
            this.ContractDetails.territoriesName =
              this.ContractDetails.territoriesName + "," + element.text;
          }
        });
      }
    },
    SelectContainerType(item, ContainerType_items) {
      this.ContainerType_items = ContainerType_items;
      this.ContractDetails.fk_cont_type_id = "";
      this.ContractDetails.contTypeName = "";
      if (ContainerType_items.length > 0) {
        this.ContractDetails.ContainerType_items = ContainerType_items;
        ContainerType_items.forEach((element) => {
          if (!this.ContractDetails.fk_cont_type_id) {
            this.ContractDetails.fk_cont_type_id = element.value;
            this.ContractDetails.contTypeName = element.text;
          } else {
            this.ContractDetails.fk_cont_type_id =
              this.ContractDetails.fk_cont_type_id + "," + element.value;
            this.ContractDetails.contTypeName =
              this.ContractDetails.contTypeName + "," + element.text;
          }
        });
      }
      this.addContainerRate(this.ContainerType_items);
    },
    getContractList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getContList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getContractList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      AccountService.getAllContractList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          console.log();
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.getContractList.length > 0) {
                this.totalData = data.totalData;
                this.getContList = data.getContractList;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.getContractList.length > 0) {
                this.totalData = data.totalData;
                this.getContList = data.getContractList;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getContList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },
    filterClear() {
      this.Filter = {
        pendingClient: "",
        clientNameFilter: "",
        clientIdFilter: "",
        branchFilter: "",
        transportTypeFilter: "Export",
        shipmentTypeFilter: "",
        jobTypeFilter: "",
      };
      this.getContractList("Normal", "0", "0", "1", "1");
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getContractList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getContractList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getContractList("Normal", "0", CURRENT, "2", event);
      // this.getContractList("Normal");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getContractList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// ContarctList.vue?79213054